export const SchemaAttributes = new Set([
    'itemScope',
    'itemType',
    'itemProp',
]);
